import Area from "../charts/Area/Area";
import Bar from "../charts/Bar/Bar";
import classNames from "../../utilities/ClassNames";
import { EmptyComponent } from "processhub-components-lib";
import React from "react";
import { ChartProps } from "./domain/types";

const Chart: React.FC<ChartProps> = ({ data, name, areaApiConfig }) => {
  return (
    data ? (
      <div className="sm:py-0 2xl:p-1 flex flex-col w-full h-full justify-center items-center">
        <div className="w-full h-full rounded-md">
          <div className="w-full h-full">
            <Area
              item={data}
              type={data.tagNameIdentifier ? "tag" : "expression"}
              areaType={"regular"}
              renderType="lazyLoading"
              maintainAspectRatio={false}
              areaApiConfig={areaApiConfig}
            />
          </div>
          {/* <div className={classNames("w-[70%]", "mx-auto")}>
            <Bar
              meta={data}
              barType={"small"}
              name={name}
            />
          </div> */}
        </div>
      </div>
    ) : (
      <EmptyComponent />
    )
  );
};

export default Chart;